import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    CreateNewUserDataModel,
    UserRolesDataModel,
    UsersDataModel,
    UsersStore
} from "@views/master-data/domain/users.model";
import {ApplicationResponse, StateTrackedData} from "@common/domain/common.model";
import api from "@common/services/api.service";

export const fetchUsers = createAsyncThunk<UsersDataModel[], void>("user/fetchUsers",
    async () => {
        const response = await api.get<ApplicationResponse<UsersDataModel[]>>("user")
        return response?.data?.data?.map(user => {
            return {
                ...user,
                roles: user.roles[0] || ""
            }
        }) as UsersDataModel[]
    })

export const fetchRoles = createAsyncThunk<UserRolesDataModel[], void>("user/fetchRoles",
    async () => {
        const response = await api.get<ApplicationResponse<UserRolesDataModel[]>>("role")
        return response.data.data || [] as UserRolesDataModel[]
    }
)

export const createNewUser = createAsyncThunk<void, CreateNewUserDataModel>("user/addNewUser",
    async (payload) => {
        const response = await api.post("user", payload)
        return response.data.data
    }
)
export const updateUser = createAsyncThunk<void, {id: string,payload:CreateNewUserDataModel}>("user/updateUser",
    async ({id,payload}) => {
        const response = await api.put("user/"+id, payload)
        return response.data.data
    }
)

export const deleteUser = createAsyncThunk<void,  string>("user/deleteUser",
    async (id) => {
        const response = await api.delete("user/"+id,)
        return response.data.data
    }
)


const usersSlice = createSlice({
    name: "user",
    initialState: {
        usersMinimal: {
            status: "loading",
            data: [],
            error: null
        } as StateTrackedData<UsersDataModel[]>,
        rolesMinimal: {
            status: "loading",
            data: [],
            error: null
        } as StateTrackedData<UserRolesDataModel[]>
    } as UsersStore,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchUsers.pending, (state) => {
            state.usersMinimal.status = "loading"
            state.usersMinimal.error = null
            state.usersMinimal.data = []
        }).addCase(fetchUsers.fulfilled, (state, action) => {
            state.usersMinimal.status = "idle"
            state.usersMinimal.data = action.payload
            state.usersMinimal.error = null
        }).addCase(fetchUsers.rejected, (state, action) => {
            state.usersMinimal.status = "failed"
            state.usersMinimal.error = action.error.message
            state.usersMinimal.data = []
        })
        builder.addCase(fetchRoles.pending, (state) => {
            state.rolesMinimal.status = "loading"
            state.rolesMinimal.error = null
            state.rolesMinimal.data = []
        }).addCase(fetchRoles.fulfilled, (state, action) => {
            state.rolesMinimal.status = "idle"
            state.rolesMinimal.data = action.payload
            state.rolesMinimal.error = null
        }).addCase(fetchRoles.rejected, (state, action) => {
            state.rolesMinimal.status = "failed"
            state.rolesMinimal.error = action.error.message
            state.rolesMinimal.data = []
        })
    }
})

export default usersSlice.reducer;